import { all } from 'redux-saga/effects';
import congratulationWatcher from './congratulationSaga';

export default function* rootSaga(action) {
	yield all([congratulationWatcher(action)]);
}
